import { css } from "styled-components";

export const typography = {
  Body: css`
    font-size: 1.7rem;
  `,
  SubText: css`
    font-size: 1.8rem;
    font-weight: 600;
  `,
  Caption: css`
    font-size: 1.4rem;
    font-weight: 300;
  `,
  Caption2: css`
    font-size: 1.3rem;
  `,
  Time: css`
    font-size: 1.4rem;
    font-weight: 500;
  `,
};
